<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modifier un sujet</strong>
          </div>
           

            <b-form-group
              label="Sujet"
              label-for="sujet"
            >
            	<b-form-input id="sujet" type="text" :class="{hasError: errors.sujet !== ''}" v-model="sujet"></b-form-input>
              <span class="field-error">{{ errors.sujet }}</span>
            </b-form-group>

            <b-form-group
              label="Email du destinataire"
              label-for="destinataire_email"
            >
              <b-form-input id="destinataire_email" type="text" :class="{hasError: errors.destinataire_email !== ''}" v-model="destinataire_email"></b-form-input>
              <span class="field-error">{{ errors.destinataire_email }}</span>
            </b-form-group>

            <b-form-group
              label="Commentaire"
              label-for="commentaire"
            >
            	<b-form-textarea 
              style="height:120px" id="commentaire" type="text" :class="{hasError: errors.commentaire !== ''}" v-model="commentaire"></b-form-textarea>
              <span class="field-error">{{ errors.commentaire }}</span>
            </b-form-group>
            

            <b-form-group
              label="Pièce jointe obligatoire"
              label-for="isPjRequired"
            >
              <b-form-checkbox id="isPjRequired" type="radio" v-model="isPjRequired" switch>{{ isPjRequired ? 'Oui' : 'Non'}}</b-form-checkbox>
            </b-form-group>
            
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des sujets
              </b-button>
              <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  getBaseUrl,
  getProvider,
  getIdToken,
  getAccessToken
} from "@/utils/auth";

export default {
  data() {
  	return {
      id : '',
  	  sujet : '',
  	  destinataire_email: '',
      isPjRequired: '',
      commentaire: '',
      errors: {
        sujet: '',
        destinataire_email: '',
        commentaire: '',
      }
  	};
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.get();
  },
  methods: {
    get() {
      this.$store.commit('IS_LOADING', true)
      let id = this.$route.params.id;
      let self = this;
       this.$axios
        .get("/espaceBeneficiaire/admincontacts/" + id)
        .then(response => {
          this.id = response.data.adminContact.id;
          this.sujet = response.data.adminContact.sujet;
          this.destinataire_email = response.data.adminContact.destinataire_email;
          this.isPjRequired = response.data.adminContact.is_pj_required;
          this.commentaire = response.data.adminContact.commentaire;
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          if(error.response && error.response.status === 404 && self != undefined){
            self.$router.push({ path: '/espace-beneficiaire/gestion-des-sujets' })
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Un probléme est survenue, merci de contacter l\'administrateur',showConfirmButton: false, timer: 5000})
          }
        });
    },
    edit() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let id = this.$route.params.id;
        let dataPost = {};
        dataPost.sujet = this.sujet;
        dataPost.destinataire_email = this.destinataire_email;
        dataPost.isPjRequired = this.isPjRequired;
        dataPost.commentaire = this.commentaire;

        this.$axios
          .put("/espaceBeneficiaire/admincontacts/edit/"+id, dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Modification du sujet avec succès', text:'Le sujet a bien été modifié',showConfirmButton: false, timer: 5000})
              this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:'Un probléme est survenue, merci de contacter l\'administration',showConfirmButton: false, timer: 5000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/espace-beneficiaire/gestion-des-sujets' })
    },
    validateData () {
      this.clearErrors();
      let regEmail = this.$store.getters.getRegMail
      let regAlpha = this.$store.getters.getRegAlpha
      let valid = true;

      if (this.sujet === "") {
        this.errors.sujet = "La sujet est obligatoire";
        valid= false;
      } else if (this.sujet.length > 90) {
         valid = false
         this.errors.sujet  = 'Veuillez entrer un sujet valide'
      }

      if (this.destinataire_email.trim() === '') {
         valid= false;
         this.errors.destinataire_email  = 'Veuillez entrer une adresse mail'
      } else if (!regEmail.test(this.destinataire_email.trim())) {
         valid = false
         this.errors.destinataire_email  = 'Veuillez entrer une adresse mail valide'
       }

      return valid;
    },
    clearErrors() {
      this.errors.sujet = "";
      this.errors.destinataire_email = "";
      this.errors.commentaire = "";
    }
  }
};
</script>

<style>
</style>
